import { PayloadAction } from '@reduxjs/toolkit';

import {
	MESSENGER_DEFAULT_PAGE_NUMBER,
	MessengerFilterTabsNames,
} from '~components/business-owner/messenger/constants';

import actionTypes from '~actionTypes';
import { createNamespacer, createReducer, ReducerHandlers } from '~utils/reducers';

export type ConversationsListSearchParamsType = {
	page: number;
	q: string;
	unread: boolean;
	isEscalated: boolean;
	isOther: boolean;
};

export type MessengerState = {
	conversationsListSearchParams: ConversationsListSearchParamsType;
	messengerActiveTab: MessengerFilterTabsNames;
};

const messengerNameSpace = 'BO-MESSENGER' as const;

export const messengerNameSpacer = createNamespacer(messengerNameSpace);
export const messengerAT = actionTypes.businessOwner.messenger;

const initialState: MessengerState = {
	conversationsListSearchParams: {
		page: MESSENGER_DEFAULT_PAGE_NUMBER,
		q: '',
		unread: false,
		isEscalated: false,
		isOther: false,
	},
	messengerActiveTab: MessengerFilterTabsNames.PRIMARY,
};

const handlers: ReducerHandlers<MessengerState> = {
	[messengerNameSpacer(messengerAT.SET_CONVERSATIONS_LIST_SEARCH_PARAMS)]: (
		state,
		action: PayloadAction<Partial<ConversationsListSearchParamsType>>,
	) => {
		return {
			...state,
			conversationsListSearchParams: {
				...state.conversationsListSearchParams,
				...action.payload,
			},
		};
	},
	[messengerNameSpacer(messengerAT.SET_MESSENGER_ACTIVE_TAB)]: (
		state,
		action: PayloadAction<MessengerFilterTabsNames>,
	) => {
		return {
			...state,
			messengerActiveTab: action.payload,
		};
	},
};

export default createReducer(initialState, handlers, [messengerNameSpace]);
